import { DataTable, Column, Skeleton } from 'primereact';
import React, { useEffect, useState} from 'react'
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {RadioButtonField} from "../../../Commons/Scripts/Componentes/RadioButtonField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, MessageProvider, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {CxpReporteService} from "../Services/cxp-reporte-service";
import { FechaUtils } from "../../../Commons/Scripts/Utils/fechaUtils";
import { useAuthentication } from '../../../Commons/Scripts/Hooks';
import { PAIS_CODIGO_DO, PAIS_CODIGO_EC, PAIS_CODIGO_CR, PAIS_CODIGO_SV, PAIS_CODIGO_GT } from '../../../Commons/Scripts/Utils/constants';

const origin = window.location.origin;

function OcultarCero({ children, valor }) {
  return <React.Fragment>{valor === 0 ? null : <span>{children}</span>}</React.Fragment>;
}

function BodySuplidor(data, field, setExpandedRows, esNumero = false) {
  return (
    <div
      style={{ width: "100%", cursor: "pointer" }}
      onClick={() => {
        const key = data.SuplidorIdSec;

        setExpandedRows((prev) => {
          if (prev?.some((p) => p.SuplidorIdSec === key)) {
            return prev?.filter((p) => p.SuplidorIdSec !== key);
          } else {
            return [...(prev || []), data];
          }
        });
      }}
    >
      {esNumero && <OcultarCero valor={data[field]}>{formatear2Decimales(data[field])}</OcultarCero>}
      {!esNumero && data[field]}
    </div>
  );
}

function TablaSaldoAntiguedad({ reporte, indice, loading, expandedRows, setExpandedRows }) {

    const { usuario } = useAuthentication();
    const [internacionalData, setInternacionalData] = useState({
        NCFheader: "NCF",
    });

    useEffect(() => {
        switch (usuario?.Compania?.Internacional) {
            case PAIS_CODIGO_EC:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_GT:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_SV:
                setInternacionalData({
                    NCFheader: "DTE"
                });
                break;
            case PAIS_CODIGO_CR:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;

            case PAIS_CODIGO_DO:
            default:
                setInternacionalData({
                    NCFheader: "NCF"
                });
                break;
        }
    }, [usuario?.Compania?.Internacional]);


  const grupoMoneda = reporte?.reduce((acc, item) => {
    const moneda = acc.find((moneda) => moneda.MonedaNombre === item.MonedaNombre);

    if (!moneda) {
      acc.push(item);
    }

    return acc;
  }, []);

  const grupoSuplidor = reporte?.reduce((acc, item) => {
    const suplidorIndex = acc.findIndex(
      (s) => s.SuplidorIdSec === item.SuplidorIdSec && s.MonedaNombre === item.MonedaNombre
    );

    if (suplidorIndex !== -1) {
      const suplidor = { ...acc[suplidorIndex] };
      suplidor.documentos.push(item);

      suplidor._0a30 += item._0a30;
      suplidor._31a60 += item._31a60;
      suplidor._61a90 += item._61a90;
      suplidor.mayor90 += item.mayor90;
      suplidor.BalanceActual += item.BalanceActual;

      acc = [...acc.slice(0, suplidorIndex), suplidor, ...acc.slice(suplidorIndex + 1)];
    } else {
      acc.push({
        ...item,
        documentos: [item],
      });
    }

    return acc;
  }, []);

  const rowExpansionTemplate = (moneda, suplidor) => {
    const filtroMoneda = reporte.filter((factura) => factura.MonedaNombre === moneda.MonedaNombre);

    const filtroSuplidor = filtroMoneda.filter((factura) => factura.SuplidorIdSec === suplidor.SuplidorIdSec);

    function crearColumna(campo, cabezera, key) {
      return (
        <Column
          key={key}
          style={{ textAlign: "right" }}
          headerClassName="alinear-derecha"
          body={(item) => {
            return (
              <OcultarCero valor={item[campo]}>
                <a className="link" href={crearLink(item.FacturaIdSec)} target="_blank">
                  {formatear2Decimales(item[campo])}
                </a>
              </OcultarCero>
            );
          }}
          header={cabezera}
          footer={() => {
            const total = filtroSuplidor.reduce((sum, item) => sum + item[campo], 0);
            return <OcultarCero valor={total}>{formatear2Decimales(total)}</OcultarCero>;
          }}
        />
      );
    }

    function crearLink(facturaIdSec) {
      return `${origin}/CxP/factura_suplidor_edit.aspx?IdSec=${facturaIdSec}`;
    }

    const columnas = [
      crearColumna("_0a30", "0-30", "0a30"),
      crearColumna("_31a60", "31-60", "31a60"),
      crearColumna("_61a90", "61-90", "61a90"),
      crearColumna("mayor90", "> 90", "mayor90"),
      crearColumna("Descuento", "Descuento", "Descuento"),
      crearColumna("Impuestos", "Impuesto", "Impuestos"),
      crearColumna("MontoOriginalFactura", "Monto Original", "MontoOriginal"),
      crearColumna("BalanceActual", "Balance Actual", "BalanceActual"),
    ];

    return (
      <DataTable value={filtroSuplidor}>
        <Column
          body={(item) => {
            const link = crearLink(item.FacturaIdSec);

            return (
              <a className="link" href={link} target="_blank">
                {item.FacturaIdSec}
              </a>
            );
          }}
          header="Id"
        />
        <Column
          body={(item) => {
            const link = crearLink(item.FacturaIdSec);

            return (
              <a className="link" href={link} target="_blank">
                {item.FacturaNCF}
              </a>
            );
          }}
                header={internacionalData?.NCFheader || "NCF"}
        />
        <Column
          body={(item) => {
            const match = item?.FechaFactura?.match(/\d+/);
            const fechaMilisegundos = match ? Number(match[0]) : null;

            return <span>{new Date(fechaMilisegundos).toLocaleDateString()}</span>;
          }}
          headerClassName="alinear-derecha"
          style={{ textAlign: "right" }}
          header="Fecha"
        />
        <Column
          body={(item) => {
            const match = item?.FechaVencimiento?.match(/\d+/);
            const fechaMilisegundos = match ? Number(match[0]) : null;

            return <span>{new Date(fechaMilisegundos).toLocaleDateString()}</span>;
          }}
          headerClassName="alinear-derecha"
          style={{ textAlign: "right" }}
          header="Vencimiento"
        />
        <Column style={{ textAlign: "right" }} headerClassName="alinear-derecha" field="DiasAntiguedad" header="Días" />
        {columnas}
      </DataTable>
    );
  };

  return (
    <div>
      {grupoMoneda?.map((moneda, index) => {
        const grupoSuplidorFiltrado = grupoSuplidor.filter((factura) => factura.MonedaNombre === moneda.MonedaNombre);

        return (
          <div key={index}>
            <div style={{ padding: "1rem 0", fontSize: "12px" }}>
              <b>Moneda:</b> {moneda.MonedaNombre}
            </div>
            <DataTable
              id="grid"
              value={grupoSuplidorFiltrado}
              expandedRows={expandedRows}
              onRowToggle={(e) => setExpandedRows(e.data)}
              rowExpansionTemplate={(item) => rowExpansionTemplate(moneda, item)}
            >
              <Column
                expander={true}
                style={{ width: "45px" }}
                body={(rowData) => {
                  const isExpanded = expandedRows?.some(
                    (p) => p.SuplidorIdSec === rowData.SuplidorIdSec && p.MonedaNombre === moneda.MonedaNombre
                  );

                  return (
                    <div
                      onClick={() => {
                        const key = rowData.SuplidorIdSec;

                        setExpandedRows((prev) => {
                          if (prev?.some((p) => p.SuplidorIdSec === key)) {
                            return prev?.filter((p) => p.SuplidorIdSec !== key);
                          } else {
                            return [...(prev || []), rowData];
                          }
                        });
                      }}
                      className={`p-row-toggler ${isExpanded ? "expanded" : ""}`}
                    >
                      <i className="pi pi-chevron-right"></i>
                    </div>
                  );
                }}
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "SuplidorIdSec", setExpandedRows)}
                field="SuplidorIdSec"
                header="Id"
              />
              <Column
                body={(item) => BodySuplidor(item, "SuplidorNombre", setExpandedRows)}
                field="SuplidorNombre"
                header="Suplidor"
              />
              <Column
                body={(item) => BodySuplidor(item, "SuplidorContacto", setExpandedRows)}
                field="SuplidorContacto"
                header="Contacto"
              />
              <Column
                body={(item) => BodySuplidor(item, "SuplidorTelefonoPrincipal", setExpandedRows)}
                field="SuplidorTelefonoPrincipal"
                header="Teléfono"
              />
              <Column
                body={(item) => BodySuplidor(item, "LimiteCredito", setExpandedRows, true)}
                field="LimiteCredito"
                header="Límite de Crédito"
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "_0a30", setExpandedRows, true)}
                header="0-30"
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "_31a60", setExpandedRows, true)}
                header="31-60"
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "_61a90", setExpandedRows, true)}
                header="61-90"
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "mayor90", setExpandedRows, true)}
                header="> 90"
              />
              <Column
                headerClassName="alinear-derecha"
                style={{ textAlign: "right" }}
                body={(item) => BodySuplidor(item, "BalanceActual", setExpandedRows, true)}
                header="Total"
              />
            </DataTable>
          </div>
        );
      })}

      {loading && indice === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </div>
  );
}

function TablaSaldoAntiguedadResumido({ filtrarReporte, reporte, indice, loading }) {
  const grupoMonedas = reporte?.reduce((acc, item) => {
    const moneda = acc.find((moneda) => moneda.MonedaNombre === item.MonedaNombre);

    if (!moneda) {
      acc.push(item);
    }

    return acc;
  }, []);

  const grupoSuplidores = reporte?.reduce((acc, item) => {
    const suplidorIndex = acc.findIndex(
      (s) => s.SuplidorIdSec === item.SuplidorIdSec && s.MonedaNombre === item.MonedaNombre
    );

    if (suplidorIndex === -1) {
      acc.push(item);
    } else {
      const suplidor = { ...acc[suplidorIndex] };

      suplidor._0a30 += item._0a30;
      suplidor._31a60 += item._31a60;
      suplidor._61a90 += item._61a90;
      suplidor.mayor90 += item.mayor90;
      suplidor.MontoOriginal += item.MontoOriginal;
      suplidor.BalanceActual += item?.BalanceActual ?? 0;

      acc[suplidorIndex] = suplidor;
    }
    return acc;
  }, []);

  function crearColumna(campo, cabezera, key, onClick) {
    return (
      <Column
        key={key}
        style={{ textAlign: "right" }}
        headerClassName="alinear-derecha"
        body={(item) => {
          return (
            <OcultarCero valor={item[campo]}>
              <span className="link" onClick={() => onClick(item)}>
                {formatear2Decimales(item[campo])}
              </span>
            </OcultarCero>
          );
        }}
        header={cabezera}
        footer={() => {
          const total = grupoSuplidores.reduce((sum, item) => sum + item[campo], 0);
          return <OcultarCero valor={total}>{formatear2Decimales(total)}</OcultarCero>;
        }}
      />
    );
  }

  function crearLink(facturaIdSec) {
    return `${origin}/CxP/suplidores_edit.aspx?IdSec=${facturaIdSec}`;
  }

  const columnInfo = [
    { campo: "_0a30", cabezera: "0-30", key: "0a30" },
    { campo: "_31a60", cabezera: "31-60", key: "31a60" },
    { campo: "_61a90", cabezera: "61-90", key: "61a90" },
    { campo: "mayor90", cabezera: "> 90", key: "mayor90" },
    { campo: "BalanceActual", cabezera: "Balance", key: "BalanceActual" },
  ];

  const columnas = columnInfo.map(({ campo, cabezera, key }) =>
    crearColumna(campo, cabezera, key, (item) => {
      filtrarReporte(item.SuplidorIdSec);
    })
  );

  return (
    <div>
      {grupoMonedas?.length > 0 &&
        grupoMonedas?.map((moneda, index) => {
          const grupoSuplidoresFiltrado = grupoSuplidores.filter(
            (factura) => factura.MonedaNombre === moneda.MonedaNombre
          );

          return (
            <div key={index}>
              <h3>Facturas en Moneda {moneda.MonedaNombre}</h3>

              <DataTable id="grid" value={grupoSuplidoresFiltrado}>
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  body={(item) => (
                    <a className="link" href={crearLink(item.SuplidorIdSec)} target="_blank">
                      {item.SuplidorIdSec}
                    </a>
                  )}
                  header="Suplidor Id"
                />
                <Column
                  body={(item) => {
                    return (
                      <a className="link" href={crearLink(item.SuplidorIdSec)} target="_blank">
                        {item.SuplidorNombre}
                      </a>
                    );
                  }}
                  header="Nombre"
                />
                <Column field="SuplidorContacto" header="Contacto" />
                <Column field="Condicion" header="Condición" />
                <Column
                  headerClassName="alinear-derecha"
                  style={{ textAlign: "right" }}
                  field="LimiteCredito"
                  header="Límite de crédito"
                />
                {columnas}
              </DataTable>
            </div>
          );
        })}

      {loading && indice === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </div>
  );
}

function Formulario({
  suplidores,
  tiposFacturacion,
  tiposSuplidor,
  periodos,
  antiguedad,
  loadingDatos,
  onSubmit,
  valorInicial = {},
  onChange,
  filtro,
  tipo,
  where,
}) {
  const form = useForm(valorInicial);

  const [periodo, setPeriodo] = useState(form.values?.periodo);
  const [fechaInicio, setFechaInicio] = useState(form.values?.fechaInicio);
  const [fechaFin, setFechaFin] = useState(form.values?.fechaFin);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXP, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXP, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.SALDO_ANTIGUEDAD_CXP, "CSV");

  useEffect(() => {
    const suplidor = suplidores?.find((c) => c.value === Number(filtro?.suplidorIdSec));

    if (suplidor) {
      form.setValue("suplidor", [suplidor]);
    }
  }, [filtro]);

  useEffect(() => {
    form.setValue("tipo", tipo || "detalle");
  }, [tipo]);

  useEffect(() => {
    if (periodo !== undefined && periodo !== "-1") {
      form.setValue("fechaInicio", undefined);
      form.setValue("fechaFin", undefined);
    }
  }, [periodo]);

  useEffect(() => {
    if (fechaInicio !== undefined && fechaFin !== undefined) {
      form.setValue("periodo", { value: "-1", label: "Seleccione un período" });
    }
  }, [fechaInicio, fechaFin]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  const handleChange = (formulario) => {
    setPeriodo(formulario?.periodo?.value);
    setFechaInicio(formulario?.fechaInicio);
    setFechaFin(formulario?.fechaFin);

    onChange(formulario);
  };

  return (
    <SimpleForm formulario={form} onChange={handleChange}>
      <div className="row">
        <SelectField
          isMulti
          name="suplidor"
          opciones={suplidores || []}
          label="Suplidor"
          placeholder="Todos"
          isLoading={loadingDatos}
          width="400px"
        />
      </div>

      <div className="row">
        <SelectField
          name="tipoFacturacion"
          opciones={tiposFacturacion || []}
          placeholder="Todos"
          label="Tipo Facturación"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
        <SelectField
          name="tipoSuplidor"
          opciones={tiposSuplidor || []}
          label="Tipo Suplidor"
          placeholder="Todos"
          isRow
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <SelectField
          name="periodo"
          opciones={periodos || []}
          label="Período"
          placeholder="Seleccione un período"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
        <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
      </div>

      <div className="row">
        <SelectField
          name="antiguedad"
          opciones={antiguedad || []}
          label="Antigüedad"
          placeholder="Todas"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <label className="label">Tipo</label>
        <div className="control">
          <div style={{ display: "flex", alignItems: "center", gap: "0 5px" }}>
            <RadioButtonField name="tipo" label="Detalle" value="detalle" />
            <RadioButtonField name="tipo" label="Resumido" value="resumido" />
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 125px",
        }}
      >
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2
          texto="PDF"
          onClick={() => handlePdf({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingPdf}
        />
        <Button2
          texto="Excel"
          onClick={() => handleExcel({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingExcel}
        />
        <Button2
          texto="CSV"
          onClick={() => handleCsv({ TipoReporte: form.values?.tipo === "resumido" ? "U" : "", ...where })}
          loading={loadingCsv}
        />
      </div>
    </SimpleForm>
  );
}

export function SaldoAntiguedad() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [expandedRows, setExpandedRows] = useState(null);

  const [loading, setLoading] = useState(false);
  const [reporte, setReporte] = useState([]);
  const [total, setTotal] = useState(0);

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [suplidores, setSuplidores] = useState();
  const [tiposFacturacion, setTiposFacturacion] = useState();
  const [tiposSuplidor, setTiposSuplidor] = useState();
  const [periodos, setPeriodos] = useState();
  const [antiguedad, setAntiguedad] = useState();

  const [where, setWhere] = useState({
    FechaInicio: FechaUtils.getSeisMesesAntes(),
    FechaFin: FechaUtils.getHoyFin(),
    IndiceDePagina: 0,
    CantidadPorPagina: 50,
  });

  const [tipo, setTipo] = useState("detalle");
  const [filtro, setFiltro] = useState();

  const totalPaginas = Math.ceil(total / where.CantidadPorPagina);
  const indice = (where.IndiceDePagina ?? 0) + 1;

  useEffect(() => {
    setLoading(true);
    clearMessages();

    CxpReporteService.consultarSaldoAntiguedad(where)
      .then((res) => {
        setReporte((prevReporte) => [...prevReporte, ...res?.Resultados]);
        setTotal(res?.Total ?? 0);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([
      CxpReporteService.consultarSuplidores(),
      CxpReporteService.consultarTiposFacturacion(),
      CxpReporteService.consultarTiposSuplidor(),
      CxpReporteService.consultarPeriodos(),
      CxpReporteService.consultarAntiguedad(),
    ])
      .then((res) => {
        const suplidores = res[0]?.map((suplidor) => {
          return {
            value: suplidor.IdSec,
            label: suplidor.Nombre,
          };
        });
        const tiposFacturacion = res[1]?.map((tipoFacturacion) => {
          return {
            value: tipoFacturacion.Value,
            label: tipoFacturacion.Label,
          };
        });
        const tiposSuplidor = res[2]?.map((tipoSuplidor) => {
          return {
            value: tipoSuplidor.IdSec,
            label: tipoSuplidor.Nombre,
          };
        });
        const periodos = res[3]?.map((periodo) => {
          return {
            value: periodo.Value,
            label: periodo.Label,
          };
        });
        const antiguedad = res[4]?.map((antiguedad) => {
          return {
            value: antiguedad.Value,
            label: antiguedad.Label,
          };
        });

        setSuplidores(suplidores);
        setTiposFacturacion(tiposFacturacion);
        setTiposSuplidor(tiposSuplidor);
        setPeriodos(periodos);
        setAntiguedad(antiguedad);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  const filtrarReporte = (suplidorIdSec) => {
    setTipo("detalle");
    setFiltro({
      suplidorIdSec,
    });
    setExpandedRows();
  };

  const handleFiltrar = (filtros) => {
    setReporte([]);
    setTotal(0);
    setWhere({
      ...filtros,
      IndiceDePagina: 0,
      CantidadPorPagina: 50,
    });
  };

  const handleMostrarMas = () => {
    setWhere((prevWhere) => ({
      ...prevWhere,
      IndiceDePagina: prevWhere.IndiceDePagina + 1,
    }));
  };

  const handleChange = (formulario) => {
    if (filtro !== undefined && filtro !== null) {
      setReporte([]);
      setTotal(0);
      setWhere((prevWhere) => ({ ...prevWhere, SuplidorIdSecList: formulario?.suplidor?.map((s) => s.value) }));
      setFiltro();
    }
  };

  return (
    <div>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        suplidores={suplidores}
        tiposFacturacion={tiposFacturacion}
        tiposSuplidor={tiposSuplidor}
        periodos={periodos}
        antiguedad={antiguedad}
        loadingDatos={loadingDatos}
        onSubmit={(formulario) => {
          let fechaFin = new Date(formulario.fechaFin);
          const ahora = new Date();
          fechaFin.setHours(ahora.getHours(), ahora.getMinutes(), ahora.getSeconds(), ahora.getMilliseconds());

          const filtros = {
            SuplidorIdSecList: formulario.suplidor?.map((s) => s.value),
            TipoSuplidor: formulario.tipoSuplidor?.value != "-1" ? formulario.tipoSuplidor?.value : null,
            Periodo: formulario.periodo?.value != "-1" ? formulario.periodo?.value : null,
            FechaInicio: formulario.fechaInicio,
            FechaFin: fechaFin,
            Antiguedad: formulario.antiguedad?.value != "-1" ? formulario.antiguedad?.value : null,
          };

          handleFiltrar(filtros);
        }}
        valorInicial={{
          fechaInicio: FechaUtils.getSeisMesesAntes(),
          fechaFin: FechaUtils.getHoyFin(),
          tipo: "detalle",
        }}
        onChange={(formulario) => {
          setTipo(formulario?.tipo);

          handleChange(formulario);
        }}
        filtro={filtro}
        tipo={tipo}
        where={where}
      />
      {tipo === "detalle" && (
        <TablaSaldoAntiguedad
          reporte={reporte}
          indice={indice}
          loading={loading}
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
        />
      )}
      {tipo === "resumido" && (
        <TablaSaldoAntiguedadResumido
          reporte={reporte}
          indice={indice}
          loading={loading}
          filtrarReporte={filtrarReporte}
        />
      )}
      {indice < totalPaginas && (
        <Button2 loading={loading} onClick={handleMostrarMas} texto={loading ? "Cargando..." : "Mostrar más"} />
      )}
    </div>
  );
}